<template>
  <div class="card p-3">
    <div class="card-block">
      <vs-row>
        <vs-col w="12">
          <vs-row>
            <vs-col w="12">
              <vs-button
                flat
                href="/panel-docentes"
              >
                Ir a home
              </vs-button>
              <h4 class="mt-4 p-2">Evaluaciones</h4>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="cicloEscolar" class="labelInput">
                        Ciclo Escolar
                    </label>
                    <vs-select :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length" @input="changeInfo('ciclo')">
                        <template v-if="ciclosEscolares.length">
                            <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.nombre_ciclo" :value="option.id">
                                {{option.nombre_ciclo}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" :value="0">
                              No hay datos
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select :loading="loadingInstitucion" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institucion" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" @input="changeInfo('institucion')">
                        <template v-if="instituciones.length">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.nombre" :value="option.id">
                                {{option.nombre}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" :value="0">
                              No hay datos
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="programa" class="labelInput">
                        Programa
                    </label>
                    <vs-select :loading="loadingPrograma" class="aqui pt-0" id="programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="!programas.length" @input="changeInfo('programa')">
                        <template v-if="programas.length">
                            <vs-option v-for="option in programas" :key="option.id"  :label="option.nombre" :value="option.id">
                                {{option.nombre}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" :value="0">
                              No hay datos
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="periodo" class="labelInput">
                        Periodo
                    </label>
                    <vs-select :loading="loadingPeriodo" class="aqui pt-0" id="periodo" placeholder="Seleccionar Programa" :key="periodoId" v-model="periodo" :disabled="!periodos.length" @input="changeInfo('periodo'), getGrupoAcademicoL()">
                            <vs-option v-for="option in periodos" :key="option.detalle_componente_id"  :label="option.nombre" :value="option.detalle_componente_id">
                                {{option.nombre}}
                            </vs-option>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3" v-if="modoCaptura == 'lista'">
                <form autocomplete="off">
                    <label for="codigo" class="labelInput">
                        Código de sesión
                    </label>
                    <vs-select :loading="loadingCodigo" class="aqui pt-0" id="codigo" placeholder="Seleccionar Código de sesión" :key="codigoId" v-model="codigo" :disabled="!codigos.length" @input="changeInfo('codigo')">
                            <vs-option v-for="option in codigos" :key="option.codigo_sesion_id"  :label="option.asignatura" :value="option.codigo_sesion_id">
                                {{option.asignatura}}
                            </vs-option>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3" v-if="modoCaptura == 'lista'">
                <form autocomplete="off">
                    <label for="materia" class="labelInput">
                        Grupo académico
                    </label>
                    <vs-select :loading="loadingGrupoL" class="aqui pt-0" id="grupo" placeholder="Seleccionar Grupo académico" :key="grupoLId" v-model="grupoL" :disabled="!gruposL.length" >
                        <template v-if="gruposL.length">
                            <vs-option v-for="option in gruposL" :key="option.id"  :label="option.nombre" :value="option.id">
                                {{option.nombre}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" :value="0">
                              No hay datos
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3" v-if="modoCaptura == 'sabana'">
                <form autocomplete="off">
                    <label for="materia" class="labelInput">
                        Grupo académico
                    </label>
                    <vs-select :loading="loadingGrupoL" class="aqui pt-0" id="grupo" placeholder="Seleccionar Grupo académico" :key="grupoSId" v-model="grupoS" :disabled="!gruposS.length" >
                        <template v-if="gruposS.length">
                            <vs-option v-for="option in gruposS" :key="option.id"  :label="option.nombre" :value="option.id">
                                {{option.nombre}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" :value="0">
                              No hay datos
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col v-if="modoCaptura == 'lista'">
              <vs-button
                  class="ml-auto"
                  @click="getAlumnoLista()"
              >
                 <i class="fas fa-search mr-2"></i> Buscar
              </vs-button>
            </vs-col>
            <vs-col v-if="modoCaptura == 'sabana'">
              <vs-button
                  class="ml-auto"
                  @click="getAlumnoSabana()"
              >
                 <i class="fas fa-search mr-2"></i> Buscar
              </vs-button>
            </vs-col>
          </vs-row>
          <listas v-show="modoLista" :users="users" :parametros="parametros" :persona="persona"  :csrf_token="csrf_token" :nivel="nivel" ref="descargarActaCalificaciones" @refreshTable="getAlumnoLista"></listas>
          <sabanas v-show="modoSabana" :users="sabana"  :persona="persona" :parametros="parametros" :nivel="nivel" :csrf_token="csrf_token" @refreshTable="getAlumnoSabana"></sabanas>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>

import cobranza from '../../api/requests/cobranza-persona'
import evaluaciones from '../../api/requests/docente/evaluaciones.js'
import listas from './listas.vue'
import sabanas from './sabanas.vue'
export default {
  components: {
    listas,
    sabanas
  },
  props: [ 'csrf_token', 'persona' ],
  data() {
    return {
      cicloEscolar: '',
      ciclosEscolares: [],
      cicloId: (new Date()).getTime(),
      loadingCiclo: false,
      institucion: '',
      instituciones: [],
      institucionId: (new Date()).getTime(),
      loadingInstitucion: false,
      programa: '',
      programas: [],
      programaId: (new Date()).getTime(),
      loadingPrograma: false,
      periodo: '',
      periodos: [],
      periodoId: (new Date()).getTime(),
      loadingPeriodo: false,
      codigo: '',
      codigos: [],
      codigoId: (new Date()).getTime(),
      loadingCodigo: false,
      grupoL: '',
      gruposL: [],
      grupoLId: (new Date()).getTime(),
      loadingGrupoL: false,
      grupoS: '',
      gruposS: [],
      grupoSId: (new Date()).getTime(),
      loadingGrupoS: false,
      campoFormativo: '',
      campoFormativos: [
            {
                id: 1,
                text: 'Lenguajes'
            },
            {
                id: 2,
                text: 'Saberes y pensamiento científico'
            },
            {
                id: 3,
                text: 'Ética, naturaleza y sociedades'
            },
            {
                id: 4,
                text:'De lo humano y lo comunitario'
            },
            {
                id: 5,
                text:'Sin campo formativo'
            }
        ],
      campoFormativoId: (new Date()).getTime(),
      loadingPeriodo: false,
      users:[],
      sabana:[],
      modoCaptura: '',
      modoLista: '',
      modoSabana: '',
      parametros: [],
      tabEva: 'evaluaciones',
      nivel: ''
    }
  },
  async created() {
    this.getciclosEscolaresDocente()
  },
  methods: {
    changeInfo(valor){
      if(valor == 'ciclo'){
        this.institucion = ''
        this.programa = ''
        this.periodo = ''
        this.codigo = ''
        this.grupoL = ''
        this.grupoS = ''
        this.users = []
        this.sabana = []
      }
      if(valor == 'institucion'){
        this.programa = ''
        this.periodo = ''
        this.codigo = ''
        this.grupoL = ''
        this.grupoS = ''
        this.users = []
        this.sabana = []
      }
      if(valor == 'programa'){
        this.periodo = ''
        this.codigo = ''
        this.grupoL = ''
        this.grupoS = ''
        this.users = []
        this.sabana = []
      }
      if(valor == 'periodo'){
        this.codigo = ''
        this.getCodigoSesion()
        this.grupoL = ''
        this.grupoS = ''
        this.users = []
        this.sabana = []
      }
      if(valor == 'codigo'){
        this.grupoL = ''
        this.grupoS = ''
        this.users = []
        this.sabana = []
      }
    },
    async getciclosEscolaresDocente(){
      try {
          this.loadingCiclo = true
          const { data: response } = await evaluaciones.getciclosEscolaresDocente()
          this.ciclosEscolares = response
          this.cicloId = (new Date()).getTime()
          this.loadingCiclo = false
      }
      catch{

      }
    },
    async getInstitucionDocente(){
      try {
          this.loadingInstitucion = true
          const { data: response } = await evaluaciones.getInstitucionDocente()
          this.instituciones = response
          this.institucionId = (new Date()).getTime()
          this.loadingInstitucion = false
      }
      catch{

      }
    },
    async getProgramaDocentes(){
      try {
        this.loadingPrograma = true
        const params = {
          ciclo_escolar_id: this.cicloEscolar,
          institucion_id: this.institucion
        }
          const { data: response } = await evaluaciones.getProgramaDocentes(params)
          this.programas = response
          this.programaId = (new Date()).getTime()
         this.loadingPrograma = false
      }
      catch{
         this.loadingPrograma = false
      }
    },
    async getPeriodosDocentes(){
      if(this.programa){
        try {
          this.loadingPeriodo = true
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            institucion_id: this.institucion,
            programa_id: this.programa
          }
          const { data: response } = await evaluaciones.getPeriodosDocentes(params)
          this.periodos = response
          this.periodoId = (new Date()).getTime()
          this.loadingPeriodo = false
        }
        catch{

        }
      }
    },
    async getModoCaptura(){
      if(this.periodo){
        try {
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            detalle_componente_id: this.periodo,
            institucion_id: this.institucion
          }
          const { data: response } = await evaluaciones.getModoCaptura(params)
            this.modoCaptura = response

        }
        catch(error){
          this.$vs.notification({
            progress: 'auto',
            color: 'danger',
            position: null,
            title: 'Error',
            text: 'No existe configuracion para evaluar este periodo.'
          })
        }
      }
    },
    async getCodigoSesion(){
      if(this.periodo){
        try {
          this.loadingCodigo = true
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            institucion_id: this.institucion,
            programa_id: this.programa
          }
          const { data: response } = await evaluaciones.getCodigoSesion(params)
          this.codigos = response
          this.codigoId = (new Date()).getTime()
          this.loadingCodigo = false
        }
        catch{

        }
      }
    },
    async getGrupoAcademicoL(){
      if(this.codigo){
        try {
          this.loadingGrupoL = true
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            codigo_sesion_id: this.codigo,
            detalle_componente_id: this.periodo
          }
          const { data: response } = await evaluaciones.getGrupoAcademicoL(params)
          this.gruposL = response
          this.grupoLId = (new Date()).getTime()
          this.loadingGrupoL = false
        }
        catch{

        }
      }
    },
    async getGrupoAcademicoS(){
      if(this.modoCaptura == 'sabana'){
        try {
          this.loadingGrupoS = true
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            detalle_componente_id: this.periodo,
            programa_id: this.programa,
            institucion_id: this.institucion
          }
          const { data: response } = await evaluaciones.getGrupoAcademicoS(params)
          this.gruposS = response
          this.grupoSId = (new Date()).getTime()
          this.loadingGrupoS = false
        }
        catch{

        }
      }
    },
    async getAlumnoLista(acta){
      if(this.grupoL){
        this.users = []
            const loading = this.$vs.loading()
        try {
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            codigo_sesion_id: this.codigo,
            detalle_componente_id: this.periodo,
            grupo_academico_id: this.grupoL
          }
          const {data: response} = await evaluaciones.getAlumnoLista(params)
          this.users = response
          this.modoLista = this.modoCaptura
          this.parametrosInfo()
          this.getNivelesAcademicos()
          if(acta == 1){
            this.$refs.descargarActaCalificaciones.descargarActa('acta')
          }
          loading.close()
        }
        catch{
          loading.close()
        }
      }
    },
    
    async getNivelesAcademicos () {
        let params = {
        programa: this.parametros.programa_id,
        institucion: this.parametros.institucion_id,
        }
        const { data: response } = await cobranza.getNivel(params) || {}
        const { opciones: niveles, default: val } = response || {}
        if (niveles){
            this.nivel = val
        }
    },
    async getAlumnoSabana(){
      if(this.grupoS){
          const loading = this.$vs.loading()
        try {
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            detalle_componente_id: this.periodo,
            programa_id: this.programa,
            institucion_id: this.institucion,
            grupo_academico_id: this.grupoS
          }
          const {data: response} = await evaluaciones.getAlumnoSabana(params)
          this.sabana = response
          this.modoSabana = this.modoCaptura
          this.parametrosInfo()
          this.getNivelesAcademicos()
          loading.close()
        }
        catch{
          this.sabana = []
          loading.close()
        }
      }else{
        this.users = []
      }
    },
    parametrosInfo(){
      const obj = {}
      this.ciclosEscolares.forEach(ciclo => {
        if(this.cicloEscolar == ciclo.id){
          obj.ciclo_id = ciclo.id
          obj.cicloEscolar = ciclo.nombre_ciclo
        }
      })
      this.instituciones.forEach(instituto => {
        if(this.institucion == instituto.id){
          obj.institucion = instituto.nombre
          obj.institucion_id = instituto.id
        }
      })
      this.programas.forEach(programa => {
        if(this.programa == programa.id){
          obj.programa_id = programa.id
          obj.programa = programa.nombre
        }
      })
      this.periodos.forEach(periodo => {
        if(this.periodo == periodo.detalle_componente_id){
          obj.periodo = periodo.nombre
          obj.periodo_id = periodo.detalle_componente_id
        }
      })
      this.codigos.forEach(codigo => {
        if(this.codigo == codigo.codigo_sesion_id){
          obj.codigo = codigo.asignatura
          obj.codigo_id = codigo.codigo_sesion_id
        }
      })
      if(this.modoCaptura == 'lista'){
        this.gruposL.forEach(grupo => {
          if(this.grupoL == grupo.id){
            obj.grupoL = grupo.nombre
            obj.grupoL_id = grupo.id
          }
        })
      }
      if(this.modoCaptura == 'sabana'){
        this.gruposS.forEach(grupo => {
          if(this.grupoS == grupo.id){
            obj.grupoS = grupo.nombre
            obj.grupoS_id = grupo.id
          }
        })
      }
      obj.programa = this.programa
      this.parametros = obj
    }
  },
  watch: {
    cicloEscolar(){
      this.getInstitucionDocente()
    },
    institucion(){
      this.getProgramaDocentes()
    },
    programa(){
      this.getPeriodosDocentes()
    },
    periodo(){
      this.getModoCaptura()
      this.getGrupoAcademicoS()
      this.getGrupoAcademicoL()
    },
    modoCaptura(){
      if(this.modoCaptura == 'lista'){
        this.getCodigoSesion()
        this.getGrupoAcademicoL()
      }else if(this.modoCaptura == 'sabana'){
        this.getGrupoAcademicoS()
      }
    },
    codigo(){
        this.getGrupoAcademicoL()
    },
    grupoS(){
      this.getAlumnoSabana()
    },
    grupoL(){
      this.getAlumnoLista()
    }
  }
}
</script>

<style>
.toolbar {
  background-color: white;
  position: sticky;
  top: 0;
}
</style>

<style lang="scss" scoped>
.divAqui {
  height: 800px;
  max-width: 100vw;
  overflow-x: auto;
  overflow-y: auto;
  position: relative;
  margin-top: 100px;
}

table {
  border-collapse: collapse;
  color: lightgrey;
  table-layout: fixed;
}

thead {
  // thead and tr don't currently support sticky
  // position: -webkit-sticky;
  // position: sticky;
  // left: 0; top: 0;
  
  th {
    position: -webkit-sticky; // for safari
    position: sticky;
    top: 0; left: 0;
    
    
    &:first-child {
      z-index: 3;
    }
  }
}

th, td {
  padding: 10px 100px;
  text-transform: capitalize;
}

th {
  background: black;
  color: white;
  white-space: nowrap;
}

tr {
  background: hsl(0, 0%, 20%);
  
  &:nth-child(even) {
    background: hsl(0, 0%, 15%);
  }
  
  &:not(:last-of-type) {
    border-bottom: 2px solid rgba(yellow, 0.25);
  }
}

th, td {
  &:first-child {
    position: -webkit-sticky; // for safari
    position: sticky;
    left: 0px;
    // top: 0px; -> doesn't work in Safari 11
    /*
      thanks to https://github.com/jonjohnjohnson
      explanation: https://github.com/w3c/csswg-drafts/issues/865 
    */
    z-index: 2;
    width: 200px;
  }
}
  
td:first-child {
  tr:nth-child(odd) & {
    background: hsl(0, 0%, 20%);
    box-shadow: inset -2px 0px rgba(black, 0.25);
  }

  tr:nth-child(even) & {
    background: hsl(0, 0%, 15%);
    box-shadow: inset -2px 0px rgba(black, 0.25);
  }
}

.botonSelect{
    border-radius: 20px;
    padding: 0.7em 1.5em;
    background: #5499C7;
    color: white;
    box-shadow: rgba(41, 128, 185, 0.2) 0px 20px 25px -5px, rgba(41, 128, 185, 0.3) 0px 10px 10px -5px;
    cursor: pointer;
}
.botonNotSelect{
    padding: 0.7em 1.3em;
    background: #F8F9F9;
    color: #5499C7;
    box-shadow: 0 0.125rem 0.25rem rgba(31, 97, 141, 0.075) !important;
    cursor: pointer;
}
</style>

